import React, { useEffect, useState } from 'react'

import { Modal } from 'react-bootstrap'

import { HttpService, API, swal, Messages, Common } from '../../config/react'

const DiamondDetail = (props) => {
  const [data, setData] = useState()

  const [isForceUpdate, setForceUpdate] = useState(false)

  useEffect(() => {
    setData(Common.GetJSON(props.props?.data.attribute_options))
    setForceUpdate(!isForceUpdate)
  }, [])

  useEffect(() => {
    setForceUpdate(!isForceUpdate)
  }, [data])

  const SoldButton = () => {
    if (props.props.data.is_sold === 1) {
      return (
        <>
          <span className="badge bg-transparent badge-danger py-2 px-0 btn-fw rounded filter-btn mr-2 fs-14">
            Sold Out
          </span>
          <button
            className="btn py-2 btn-primary btn-fw rounded filter-btn border-0 mr-2"
            onClick={(e) => OnClickRevertSoldDiamond(0)}
          >
            Add to Inventory
          </button>
        </>
      )
      // return  <button type="button" value="Sold" className='btn btn-primary btn-fw rounded filter-btn mr-2'>Sold Out</button>
    } else {
      return (
        <button
          type="button"
          value="Sold"
          className="btn py-2 btn-primary btn-fw rounded filter-btn border-0 mr-2"
          onClick={(e) => OnClickSoldDiamond(1)}
        >
          Mark as sold
        </button>
      )
    }
  }
  const closeModal = () => {
    props.onCloseModal(true)
  }
  const OnClickSoldDiamond = (issold) => {
    swal(Messages.diamondSoldProp).then(function (isConfirm) {
      if (isConfirm) {
        HttpService.postApi(API.SetSoldDiamondBySKU, {
          sku: props.props.data.sku,
          issold
        }).then((response) => {
          props.onCloseModal(true)
        })
      }
    })
  }
  const OnClickRevertSoldDiamond = (issold) => {
    swal(Messages.diamondReverSoldProp).then(function (isConfirm) {
      if (isConfirm) {
        HttpService.postApi(API.SetSoldDiamondBySKU, {
          sku: props.props.data.sku,
          issold
        }).then((response) => {
          props.onCloseModal(true)
        })
      }
    })
  }

  return (
    <Modal
      show={props.props.IsShowModal}
      onHide={closeModal}
      keyboard={true}
    >
      <Modal.Header>
        <div>
          <h6>
            {props.props.data.is_gemstone === 1 ? 'Gemstone' : 'Diamond'} Detail (SKU:{' '}
            {props.props.data.sku})
          </h6>
          {/* {props.props.data.is_sold == 1 }?<><button type="button" value="Sold" className='btn btn-primary btn-fw rounded filter-btn mr-2'>Sold Out</button> <button className='btn btn-primary btn-fw rounded filter-btn mr-2' onClick={e=>OnClickRevertSoldDiamond(0)}>Revert sold</button></>:
                <button type="button" value="Sold" className='btn btn-primary btn-fw rounded filter-btn mr-2' onClick={OnClickSoldDiamond(1)}>Mark as sold</button> */}
          <SoldButton></SoldButton>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
            ></line>
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
            ></line>
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="p-0">
          <div className="row">
            <div className="col-lg-12 stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="row justify-content-between">
                    {/* <div className="col-md-12">
                      <div className="card-header p-0 mb-3"></div>
                    </div> */}
                    <div className="col-md-12">
                      <div className="address-info">
                        <table className="table table-striped table-borderless table-diamond-detail">
                          <tbody>
                            {data !== undefined &&
                              data.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="text-black">
                                      <b>{item.title}</b>
                                    </td>
                                    <td>{item.value}</td>
                                  </tr>
                                )
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DiamondDetail
